'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

interface SmartBackButtonProps {
  fallbackUrl: string;
  label: string;
  backLabel: string;
}

export function SmartBackButton({ fallbackUrl, label, backLabel }: SmartBackButtonProps) {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if there's history to go back to
    // We check if the referrer is from the same domain
    const referrer = document.referrer;
    const isSameDomain = referrer ? new URL(referrer).hostname === window.location.hostname : false;
    setCanGoBack(isSameDomain && window.history.length > 1);
    setIsReady(true);
  }, []);

  const handleBack = () => {
    if (canGoBack) {
      router.back();
    } else {
      router.push(fallbackUrl);
    }
  };

  return (
    <button
      onClick={handleBack}
      className="group inline-flex items-center gap-2 bg-white/70 dark:bg-dark/20 hover:bg-white/95 text-sm font-medium py-2 px-3 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 backdrop-blur-sm text-gray-800 dark:text-zinc-100"
    >
      <svg className="w-4 h-4 transition-transform duration-200 group-hover:-translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      <span className={`${!isReady ? 'opacity-0' : 'opacity-100'} transition-opacity duration-150`}>
        {canGoBack ? backLabel : label}
      </span>
    </button>
  );
}

